import { FormRule } from 'src/modules/form/types/FormRule';
import * as R from 'src/modules/form/utils/rules';
import { ShareProjectForm } from 'src/modules/sharing-projects/types/ShareProjectForm';

export const SHARE_PROJECT_FORM_SCHEMA: (emailsArray: string[]) => FormRule<ShareProjectForm> = (
  emailsArray,
) => R.struct({
  role: R.pass(),
  user: (user, context) => R.allOf(
    [
      R.emailAlreadyExist(emailsArray),
      R.nonEmpty(),
      R.email(),
    ],
  )(user?.value || '', context),
});
